$(function() {
  
  
  const countryName = [
     {"country":"Canada","code":"ca"},
     {"country":"Ireland","code":"ie"},
     {"country":"Netherlands","code":"nl"} ,
     {"country":"Australia","code":"au"} ,
     {"country":"France","code":"fr"} ,
     {"country":"Germany","code":"de"} ,
     {"country":"Italy","code":"it"} ,
     {"country":"United Arab Emirates","code":"ae"} ,
     {"country":"Saudi Arabia","code":"sa"} ,
     {"country":"Switzerland","code":"ch"} ,
     {"country":"Spain","code":"es"} ,
     {"country":"India","code":"in"} ,
     {"country":"Israel","code":"il"} ,
     {"country":"Belgium","code":"be"} ,
     {"country":"Sweden","code":"se"} ,
     {"country":"Oman","code":"om"},
     {"country":"Kuwait ","code":"kw"},
     {"country":"Qatar","code":"qa"}
    ];

    function getCountryName(country) {
      var keys = ["code"];
      var values = [country];

      var result = countryName.filter(function(e) {
        return keys.every(function(a) {
          return values.includes(e[a]);
        });
      });;
     var cval = result[0]["country"];
     return cval;
    }
    function getSubdomain(){
       var host = window.location.host
       var subdomain = host.split('.')[0];
       return subdomain;
    }
     var subdomain = getSubdomain();
     if(subdomain !="pixibeauty" && subdomain !="" && subdomain!= undefined){
       console.log("domain-other",subdomain);
       var country_name = getCountryName(subdomain);
       if(country_name != "" && country_name != undefined){
         $('.open-popup-link').html(country_name);
       }
     }else{
       $('.open-popup-link').html("United Kingdom");  
     }
  
  $( ".open-popup-link" ).click(function() {
     $('body').addClass('country-open');
    $(".country-popup-wrap button.mfp-close").focus();
  });
  $( ".mfp-close,.popup-overlay" ).click(function() {
     $('body').removeClass('country-open');
    $(".open-popup-link").focus();
  });
 
  $( ".confirm-btn" ).click(function() {
   var ref_url =  $("#country-select-input").find(':selected').attr('data-url');
    if(ref_url != undefined){
      window.location.replace("https://"+ref_url);
    }
  });
  $('.open-popup-link').click(function(){
       var subdomain = getSubdomain();
      $("#country-select-input option[value="+subdomain+"]").prop("selected", true);
      //$('#country-select-input').prop('selectedIndex', 0);
  });
  $('.top_action.top_country').click(function(){
      $('.open-popup-link').trigger('click');
  });
  $('.mobile-nav .open-popup-link').click(function(){
	$('.mob_closeIcon').trigger('click');
	});
  
    $('.site-footer .country-top-btn').click(function(){
	$('.open-popup-link').trigger('click')
    });
  
   $(document).on("click",".express__checkout",function() { 

         setTimeout(function(){ 

          var cfooter_ht = $('.ajaxcart__footer').height();
          var topheight = $('.drawer__header').height() + $('.price-freeship').height();

          var footertop = $(".ajaxcart__footer").offset().top;
          var scrollerTop = $(".overflowControl").offset().top;

          cfooter_ht = $('.ajaxcart__footer').height();

          var ifheight = footertop - scrollerTop;

          $('.overflowControl').css({
            'max-height': ifheight
          });
          $('.nano-content').css({
            'max-height': ifheight
          });

         }, 4000);

      });
     
});

/* UK ADA fixes - ID: 58 */

let countryModal = document.querySelector('#country');
let firstFocusableElementNew = $('#country').children()[0];
let lastFocusableElementNew = $('#country').children()[$('#country').children().length-1];

countryModal.addEventListener('keydown', function(e) {
  if(e.target == firstFocusableElementNew && e.key == 'Tab' && e.shiftKey) {
    e.preventDefault();

        lastFocusableElementNew.focus();

  } else if(e.target == lastFocusableElementNew && e.key == 'Tab' && !e.shiftKey) {
    e.preventDefault();

        firstFocusableElementNew.focus();
    
  }
});